export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10795.c74bf95c.jpg";